export const types = {
    GET_GOOGLE_DFP_REQUEST: "GET_GOOGLE_DFP_REQUEST",
    GET_GOOGLE_DFP_SUCCESS: "GET_GOOGLE_DFP_SUCCESS",
    GET_GOOGLE_DFP_ERROR: "GET_GOOGLE_DFP_REQUEST",
    NO_ADVERT_ON_SLOT: "NO_ADVERT_ON_SLOT",
}



// WEBPACK FOOTER //
// src/client/components/common/adverts/googleDFP/lib/actions/types.js